import { z } from 'zod';
import { CURRENCY_CODES, LOCALE_CODES, TRADE_DIRECTIONS } from '../enums';

export const currencyCodeSchema = z.enum(CURRENCY_CODES);
export const localeCodeSchema = z.enum(LOCALE_CODES);
export const tradeDirectionSchema = z.enum(TRADE_DIRECTIONS);

export const uuidSchema = z.string().uuid();

/** keyset 커서 페이지네이션 공통 쿼리 */
export const cursorQuerySchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});

export interface Paginated<T> {
  items: T[];
  nextCursor: string | null;
}

/** 금액: KRW/JPY 정수 */
export const amountSchema = z.number().int().positive().max(99_999_999);

/** storage path 배열 (이미지) */
export const imagePathsSchema = z.array(z.string().min(1).max(500)).max(5);
